import {
    IListState,
    initialListState
} from '../shared/list/list.state';

export interface ISettingsState {
    settings: string;
    suggestions: IListState;
    isFetching: boolean;
}

export function initialSettingsState(): ISettingsState {
    return {
        settings: null,
        suggestions: {
            ...initialListState, sortBy: null
        },
        isFetching: false
    };
}
